import axios from 'axios';
import { constants } from '../common/constants/constants';

/**
 * The public email-preferences routes, called with the emailed token only. A plain instance on purpose: the shared
 * one would attach a stored session token, refresh it on a 401, and open the error page or a global toast on errors,
 * none of which belongs on a page anyone with the link can open.
 */
export const emailPreferencesClient = axios.create({ baseURL: constants.API_BASE_URL, timeout: 15000 });

export const UNSUBSCRIBE_STATES = {
    NO_TOKEN: 'noToken',
    IMPERSONATING: 'impersonating',
    CONFIRM: 'confirm',
    LOADING: 'loading',
    DONE: 'done',
    ALREADY: 'already',
    SUBSCRIBED: 'subscribed',
    INVALID: 'invalid',
    USE_SETTINGS: 'useSettings',
    RETRY: 'retry',
};

// only the answers the contract names become a state; anything else is unknown, and unknown is "try again"
const UNSUBSCRIBE_ANSWERS = { done: UNSUBSCRIBE_STATES.DONE, already: UNSUBSCRIBE_STATES.ALREADY };
const SUBSCRIBE_ANSWERS = { subscribed: UNSUBSCRIBE_STATES.SUBSCRIBED };

/** 400 is a bad or expired link, 409 means Settings; 429, 5xx, a network error or a timeout can be retried. */
export const stateOfError = error => {
    const status = error?.response?.status;

    if (status === 400) {
        return UNSUBSCRIBE_STATES.INVALID;
    }
    if (status === 409) {
        return UNSUBSCRIBE_STATES.USE_SETTINGS;
    }
    return UNSUBSCRIBE_STATES.RETRY;
};

const post = async (path, token, answers) => {
    try {
        const { data } = await emailPreferencesClient.post(path, { token });

        const state = data?.state;

        return typeof state === 'string' && Object.prototype.hasOwnProperty.call(answers, state)
            ? answers[state]
            : UNSUBSCRIBE_STATES.RETRY;
    } catch (error) {
        return stateOfError(error);
    }
};

export const unsubscribeByLink = token => post('/email-preferences/unsubscribe', token, UNSUBSCRIBE_ANSWERS);

export const subscribeByLink = token => post('/email-preferences/subscribe', token, SUBSCRIBE_ANSWERS);
